/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
// import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Tooltip } from '../../Components/Tooltip';
import { FormatedDate } from '../../Components/FormatedDate';

export const columns = (handleOnClick, strings, i18n) => {
  const uid = 'id';

  // TODO: https://github.com/bvaughn/react-virtualized/blob/master/source/CellMeasurer/CellMeasurer.DynamicHeightTableColumn.example.js#L70-L94
  const StatusColumnCellRenderer = ({
    // eslint-disable-next-line react/prop-types, no-unused-vars
    dataKey,
    // eslint-disable-next-line react/prop-types, no-unused-vars
    parent,
    // eslint-disable-next-line react/prop-types, no-unused-vars
    rowData,
    // eslint-disable-next-line react/prop-types
    cellData,
    // eslint-disable-next-line react/prop-types, no-unused-vars
    rowIndex,
    // eslint-disable-next-line react/prop-types, no-unused-vars
    contractStatus,
  }) => {
    let cell;
    let label;
    switch (cellData) {
      case 'quote':
        label = strings['contracts.filter.status.options.quote.label'] || 'Devis';
        break;
      case 'active':
        label = strings['contracts.filter.status.options.active.label'] || 'Actif';
        break;
      case 'project':
        label = strings['contracts.filter.status.options.project.label'] || 'Projet';
        break;
      case 'pending':
        label = strings['contracts.filter.status.options.pending.label'] || 'Suspendu';
        break;
      case 'declined':
        label = strings['contracts.filter.status.options.declined.label'] || 'Decliné';
        break;
      case 'terminated':
        label = strings['contracts.filter.status.options.terminated.label'] || 'Résilié';
        break;

      default:
        label = cellData;
        break;
    }
    try {
      cell = (
        <div
          title={label}
          style={{
            alignItems: 'center',
            justifyContent: 'left',
            display: 'flex',
          }}
        >
          <div className={`status ship2 ${cellData}`} />
          <div className={`status label ${cellData}`}>{label}</div>
        </div>
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  // eslint-disable-next-line
  const ActionsColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    const getIcon = action => {
      switch (action.get('action')) {
        case 'modify':
          return <EditIcon fontSize="small" />;
        case 'cancel':
          return <DeleteIcon fontSize="small" />;
        case 'view':
          return <RemoveRedEyeIcon fontSize="small" />;
        case 'link':
          return <OpenInNewIcon fontSize="small" />;

        default:
          return strings[action.get('label')];
      }
    };
    const getColor = action => {
      switch (action.get('action')) {
        case 'modify':
          return 'primary';
        case 'cancel':
          return 'secondary';
        case 'view':
          return 'primary';
        case 'link':
          return 'primary';

        default:
          return 'primary';
      }
    };
    const actions = [];
    try {
      cellData.forEach(action => {
        if (action.get('type') === 'action') {
          actions.push(
            <Tooltip
              key={`tooltip-${action.get('route')}-${rowData.get(uid)}`}
              title={strings[action.get('label')]}
              placement="left"
            >
              <IconButton
                size="small"
                className={getColor(action)}
                key={`${action.get('route')}-${rowData.get(uid)}`}
                label={strings[action.get('label')]}
                aria-label={strings[action.get('label')]}
                color={getColor(action)}
                onClick={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    action: action.get('action'),
                    id: rowData.get(uid),
                  })
                }
                onTouchEnd={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    id: rowData.get(uid),
                  })
                }
              >
                {/* {strings[action.get('label')]} */}
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        } else {
          const route = rowData.get('contractNumber')? `/contracts/edit?contract_number=${rowData.get('contractNumber') || rowData.get('quoteNumber')}` : `/contracts/edit?quote_number=${rowData.get('quoteNumber')}`;
          const link = props => <Link to={route} {...props} />;
          actions.push(
            <Tooltip
              key={`tooltip-${action.get('route')}-${rowData.get(uid)}`}
              title={strings[action.get('label')]}
              placement="left"
            >
              <IconButton
                className={getColor(action)}
                component={({ ...props }) => link(props)}
                size="small"
                key={`${action.get('route')}-${rowData.get(uid)}`}
                label={strings[action.get('label')]}
                aria-label={strings[action.get('label')]}
                color={getColor(action)}
              >
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        }
      });
    } catch (e) {
      actions.push(`Invalid link: ${e}`);
    }

    return <>{actions}</>;
  };

  ActionsColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const ProductColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    let cell;
    try {
      //
      const route = `/products/${rowData.get('productId')}`;
      const link = props => <Link to={route} {...props} />;
      cell = cellData ? (
        <Button
          title={cellData}
          component={({ ...props }) => link(props)}
          key={`product-${rowData.get(uid)}`}
          color="primary"
          className="primary"
          style={{ padding: '8px 4px' }}
        >
          {cellData}
          {/* &nbsp;
          <OpenInNewIcon fontSize="small" /> */}
        </Button>
      ) : (
        undefined
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  ProductColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const IdColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    let cell;
    try {
      //
      const route = rowData.get('contractNumber')? `/contracts/edit?contract_number=${rowData.get('contractNumber') || rowData.get('quoteNumber')}` : `/contracts/edit?quote_number=${rowData.get('quoteNumber')}`
      const link = props => <Link to={route} {...props} />;
      cell = cellData ? (
        <Button
          title={rowData.get('quoteNumber') || rowData.get('id')}
          component={({ ...props }) => link(props)}
          key={`product-${rowData.get(uid)}`}
          color="primary"
          className="primary"
          style={{ padding: '8px 4px' }}
        >
          {rowData.get('contract_number') || rowData.get('quoteNumber') || rowData.get('id')}
        </Button>
      ) : (
        undefined
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  IdColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const PartyColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    let cell;
    try {
      //
      const route = `/party/${rowData.get('partyId')}`;
      const link = props => <Link to={route} {...props} />;
      cell = cellData ? (
        <Button
          title={cellData}
          component={({ ...props }) => link(props)}
          key={`product-${rowData.get(uid)}`}
          color="primary"
          className="primary"
          style={{ padding: '8px 4px' }}
        >
          {cellData}
        </Button>
      ) : (
        undefined
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  PartyColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const CreatedDateCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    try {
      return <FormatedDate date={cellData} i18n={i18n} />;
    } catch (error) {
      return cellData;
    }
  };

  CreatedDateCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  return [
    {
      name: 'quoteNumber',
      label: strings['contracts.grid.column.id.label'] || 'ID',
      width: 25,
      type: 'rendered',
      render: IdColumnCellRenderer,
    },
    {
      name: 'status',
      label: strings['contracts.grid.column.status.label'] || 'Status',
      width: 70,
      type: 'rendered',
      render: StatusColumnCellRenderer,
    },
    {
      name: 'partyName',
      label: strings['contracts.grid.column.partyName.label'] || 'Subscriber',
      width: 160,
      type: 'rendered',
      render: PartyColumnCellRenderer,
    },
    {
      name: 'createdDate',
      label: strings['contracts.grid.column.createdDate.label'] || 'Creation Date',
      width: 120,
      type: 'rendered',
      render: CreatedDateCellRenderer,
    },
    {
      name: 'commercialProductName',
      label: strings['contracts.grid.column.commercialProductName.label'] || 'Product',
      width: 80,
      type: 'rendered',
      render: ProductColumnCellRenderer,
    },
    {
      name: 'actions',
      label: strings['contracts.grid.column.actions.label'] || 'Actions',
      width: 80,
      type: 'rendered',
      render: ActionsColumnCellRenderer,
    },
  ];
};

const defaultStatusOptions = [
  {
    label: 'project',
    value: 'project',
    strings: 'options.status.project.label',
    color: '',
  },
  {
    label: 'pending',
    value: 'pending',
    strings: 'options.status.pending.label',
    color: '',
  },
  {
    label: 'submitted',
    value: 'submitted',
    strings: 'options.status.submitted.label',
    color: '',
  },
  {
    label: 'canceled',
    value: 'canceled',
    strings: 'options.status.canceled.label',
    color: '',
  },
];
// FILTERS OPTIONS
export const statusOptions = (strings, options = defaultStatusOptions) => {
  const locOptions = [];

  options.forEach(option => {
    locOptions.push({
      value: option.value || option.id,
      label: strings[option.strings] || option.label,
      id: option.id,
      color: option.color,
    });
  });

  return locOptions;
};

// ================
// FILTERS UI
// ================
const getStatusOptions = ({ contractStatus }) => {
  // const { selection } = contractStatus;
  // No equivalent in V2 at the moment => hard code possible contract status
  const selection = [
    [
        "quote",
        "Devis"
    ],
    [
        "active",
        "Actif"
    ],
    [
        "hold",
        "Suspendu"
    ],
    [
        "void",
        "Sans Effet"
    ],
    [
        "terminated",
        "Résilié"
    ],
    [
        "declined",
        "Décliné"
    ]
  ]
  return Array.isArray(selection) ? selection.map(option => ({ value: option[0], label: option[1] })) : [];
};

const getCommercialproductsOptions = ({ commercialproducts }) =>
  Array.isArray(commercialproducts)
    ? commercialproducts.map(option => ({
        value: String(option.id),
        label: String(option.name),
      }))
    : [];

const getIsOutstandingOptions = ({ options = {} }) =>
  Object.entries(options).map(([value, label]) => ({
    value,
    label,
  }));

export const filtersUI = ({ strings, contractStatus, commercialproducts }) => ({
  query: {
    value: '',
    label: strings['contracts.filter.query.label'] || 'Filter by Id or Subscriber',
    placeholder: strings['contracts.filter.query.placeholder'] || 'eg. Paul Smith or 34G78... ',
    type: 'text',
    name: 'query',
  },
  status: {
    value: [],
    options: getStatusOptions({ contractStatus }),
    label: strings['contracts.filter.status.label'] || 'Filter by Status',
    name: 'status',
    type: 'checkbox',
  },
  commercialProductId: {
    value: {
      name: undefined,
      id: undefined,
    },
    options: commercialproducts ? getCommercialproductsOptions({ commercialproducts }) : [],
    label: strings['contracts.filter.product.label'] || 'Filter by Product',
    name: 'commercialProductId',
    type: 'checkbox',
  },
  isOutstanding: {
    value: {
      name: undefined,
      id: undefined,
    },
    options: getIsOutstandingOptions({ options: strings['contracts.filter.isOutstanding.options'] }),
    label: strings['contracts.filter.isOutstanding.label'] || 'Filter by Contract',
    name: 'isOutstanding',
    type: 'checkbox',
  },
  currentMonth: {
    value: { name: undefined, id: undefined },
    options: [{ label: strings['contracts.filter.currentMonth.options.currentMonth'], value: 'true' }],
    label: strings['contracts.filter.currentMonth.label'] || 'Filter by Date',
    name: 'currentMonth',
    type: 'checkbox',
  },
});
